module.exports = __webpack_public_path__ + "static/media/fashion-image-1.c31ab023.png";